import {
  SET_DOCUMENT_SELECTION_DATA,
  REMOVE_DOCUMENT_SELECTION_DATA,
  CLEAR_DOCUMENT_SELECTION_DATA
} from '../actions';
import {
  SelectedDocumentModel,
  SelectedDocumentModelActions
} from '../mappers/SelectedDocumentTypesMapper';
import produce, {Draft} from 'immer';
export const initialSelectedDocumentState: SelectedDocumentModel = {
  selectionData: []
};

export const selectedDocumentReducer = produce(
  (
    state: Draft<SelectedDocumentModel>,
    action: SelectedDocumentModelActions
  ) => {
    switch (action.type) {
      case SET_DOCUMENT_SELECTION_DATA:
        // eslint-disable-next-line no-case-declarations
        const listData: any = action.payload?.data;
        state.selectionData = listData;
        break;
      case REMOVE_DOCUMENT_SELECTION_DATA:
        // eslint-disable-next-line no-case-declarations
        const removeIndex: any = action.payload?.data;
        state.selectionData.splice(removeIndex, 1);
        break;
      case CLEAR_DOCUMENT_SELECTION_DATA:
        // eslint-disable-next-line no-case-declarations
        state.selectionData.length = 0;
        break;
      default:
        break;
    }
  },
  initialSelectedDocumentState
);
